import MediaPreview from './MediaPreview';

export default MediaPreview;
